(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('TypeRemisecommercialeDialogController', TypeRemisecommercialeDialogController);

    TypeRemisecommercialeDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'TypeRemisecommerciale'];

    function TypeRemisecommercialeDialogController ($scope, $stateParams, $uibModalInstance, entity, TypeRemisecommerciale) {
        var vm = this;
        vm.typeRemisecommerciale = entity;
        vm.load = function(id) {
            TypeRemisecommerciale.get({id : id}, function(result) {
                vm.typeRemisecommerciale = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:typeRemisecommercialeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.typeRemisecommerciale.id !== null) {
                TypeRemisecommerciale.update(vm.typeRemisecommerciale, onSaveSuccess, onSaveError);
            } else {
                TypeRemisecommerciale.save(vm.typeRemisecommerciale, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
